<script>
import { mapGetters } from 'vuex'
import actions from './actions'
import HiddenInput from '@/components/input/HiddenInput'
import MultiSelect from '@/components/input/MultiSelect'
import InputCheckbox from '@/components/input/Checkbox'
import InputBlock from '@/components/input/Block'
import InputLine from '@/components/input/Line'
import InputPhone from '@/components/input/Phone'
export default {
    components: {
        InputPhone,
        InputLine,
        InputBlock,
        InputCheckbox,
        MultiSelect,
        HiddenInput,
    },
    mixins: [actions],

    data() {
        return {
            typedLang: null,
            selectedLanguages: null,
            user: {},
        }
    },

    computed: {
        ...mapGetters({ me: 'user', languages: 'languages' }),
    },

    mounted() {
        this.user = this.me
        this.selectedLanguages = this.user.languages
    },

    methods: {
        undoLanguages(original) {
            this.user.languages = original
            this.selectedLanguages = original
        },
    },
}
</script>

<template lang="pug">
acrm-panel
    .row
        .col-md-12
            hidden-input.mb-3(v-model="user.firstname" @save="save")
                label {{ $t('USERS.NAME')}}
                div {{ user.display_name }}
                template(slot="edit")
                    input-line.mb-1(v-model="user.firstname") {{ $t('USERS.FIRSTNAME')}}
                    input-line.mb-1(v-model="user.lastname") {{ $t('USERS.LASTNAME')}}
            hidden-input.mb-3(v-model="user.phone" @save="save")
                label {{ $t('USERS.PHONE')}}
                div {{ user.phone }}
                input-phone.mb-1(slot="edit" v-model="user.phone") {{ $t('USERS.PHONE')}}
            hidden-input.mb-3(v-model="user.email" @save="save")
                label {{ $t('USERS.EMAIL')}}
                div {{ user.email }}
                input-line.mb-1(type="email" slot="edit" v-model="user.email") {{ $t('USERS.EMAIL')}}
            hidden-input.mb-3(v-model="user.type" @save="save")
                label {{ $t('USERS.TYPE')}}
                div {{ user.type }}
                input-line.mb-1(slot="edit" v-model="user.type") {{ $t('USERS.TYPE')}}
            hidden-input.mb-3(v-model="user.languages" @save="save" @undo="undoLanguages")
                label {{ $t('USERS.LANGUAGES')}}
                div
                    span.mr-2(v-for="lang in user.languages" :key="lang.id") {{ lang.translated }}
                multi-select(
                    slot="edit"
                    v-model="selectedLanguages"
                    :multiple="true"
                    :options="languages"
                    option-label="translated"
                    track-by="id"
                    @input="user.languages = selectedLanguages"
                    ) {{ $t('USERS.LANGUAGES')}}
            hidden-input.mb-3(v-model="user.nt" @save="save")
                label {{ $t('USERS.NT')}}
                div {{ user.nt }}
                input-line.mb-1(slot="edit" v-model="user.nt") {{ $t('USERS.NT')}}
            hidden-input.mb-3(v-model="user.comment" @save="save")
                label {{ $t('USERS.COMMENT')}}
                div {{ user.comment }}
                input-block.mb-1(slot="edit" v-model="user.comment") {{ $t('USERS.COMMENT')}}

            hidden-input.mb-3(v-if="user.is_notifications_muted != undefined" v-model="user.is_notifications_muted" @save="save")
                label {{ $t('USERS.NOTIFICATIONS_MUTED') }}
                div {{ user.is_notifications_muted == true ? $t('BASE.YES') : $t('BASE.NO') }}
                input-checkbox.mb-1(slot="edit" v-model="user.is_notifications_muted") {{ $t('USERS.NOTIFICATIONS_MUTED')}}

            hidden-input.mb-3(v-if="user.locale != undefined" v-model="user.locale" @save="save")
                label {{ $t('USERS.SYSTEM_LANGUAGES') }}n
                div {{ user.locale }}
                multi-select(
                    slot="edit"
                    v-model="user.locale"
                    :options="['hu', 'en']"
                ) {{ $t('USERS.SYSTEM_LANGUAGES') }}

            hidden-input.mb-3(v-model="user.id_number" @save="save")
                label {{ $t('USERS.ID_NUMBER')}}
                div {{ user.id_number }}
                input-line.mb-1(slot="edit" v-model="user.id_number") {{ $t('USERS.ID_NUMBER')}}
            hidden-input.mb-3(v-model="user.address" @save="save")
                label {{ $t('USERS.ADDRESS')}}
                div {{ user.address }}
                input-line.mb-1(slot="edit" v-model="user.address") {{ $t('USERS.ADDRESS')}}
            hidden-input.mb-3(v-model="user.bank_account" @save="save")
                label {{ $t('USERS.BANK_ACCOUNT')}}
                div {{ user.bank_account }}
                input-line.mb-1(slot="edit" v-model="user.bank_account") {{ $t('USERS.BANK_ACCOUNT')}}
            hidden-input.mb-3(v-model="user.swift_code" @save="save")
                label {{ $t('USERS.SWIFT_CODE')}}
                div {{ user.swift_code }}
                input-line.mb-1(slot="edit" v-model="user.swift_code") {{ $t('USERS.SWIFT_CODE')}}

</template>
